import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { IContact } from '../../store/contacts/contacts-interfaces';

export interface IContactFormTypes {
	[CONTACT_FORM_FIELDS.FIRST_NAME]: string,
	[CONTACT_FORM_FIELDS.LAST_NAME]: string,
	[CONTACT_FORM_FIELDS.PHONE]: string,
	[CONTACT_FORM_FIELDS.EMAIL]: string,
	[CONTACT_FORM_FIELDS.PROFILE_URL]: string,
}

export interface IContactFormReturnTypes {
	firstName: string,
	lastName: string,
	phone: string,
	email: string,
	profileUrl: string,
	id?: string,
}

export enum CONTACT_FORM_FIELDS {
	FIRST_NAME = 'firstName',
	LAST_NAME = 'lastName',
	PHONE = 'phone',
	EMAIL = 'email',
	PROFILE_URL = 'profileUrl',
}

export enum CONTACT_FORM_FIELDS_NAMES {
	FIRST_NAME = 'First name',
	LAST_NAME = 'Last name',
	PHONE = 'Phone',
	EMAIL = 'Email',
	PROFILE_URL = 'Profile url',
}

export const getContactDetailsSchema = (t): Yup.SchemaOf<IContactFormTypes> => Yup.object<Shape<IContactFormTypes>>().shape ({
	[CONTACT_FORM_FIELDS.FIRST_NAME]: Yup.string()
		.required('First name is  required'),
	[CONTACT_FORM_FIELDS.LAST_NAME]: Yup.string()
		.required('Last name is  required'),
	[CONTACT_FORM_FIELDS.PHONE]: Yup.string()
		.required('Phone is  required'),
	[CONTACT_FORM_FIELDS.EMAIL]: Yup.string()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
		.required('Email is  required'),
	[CONTACT_FORM_FIELDS.PROFILE_URL]: Yup.string()
		.required('Profile url is  required'),
});

export const contactInitialValues: IContactFormTypes = {
	[CONTACT_FORM_FIELDS.FIRST_NAME]: '',
	[CONTACT_FORM_FIELDS.LAST_NAME]: '',
	[CONTACT_FORM_FIELDS.PHONE]: '',
	[CONTACT_FORM_FIELDS.EMAIL]: '',
	[CONTACT_FORM_FIELDS.PROFILE_URL]: ''
};

export const convertToContactInitialValues = (data: IContact): IContactFormTypes => ({
	[CONTACT_FORM_FIELDS.FIRST_NAME]: data?.firstName,
	[CONTACT_FORM_FIELDS.LAST_NAME]: data?.lastName,
	[CONTACT_FORM_FIELDS.PHONE]: data?.phone,
	[CONTACT_FORM_FIELDS.EMAIL]: data?.email,
	[CONTACT_FORM_FIELDS.PROFILE_URL]: data?.phone
});

export const getFormattedContactFields = (formikValues): IContactFormReturnTypes => ({
	firstName: formikValues?.[CONTACT_FORM_FIELDS.FIRST_NAME],
	lastName: formikValues?.[CONTACT_FORM_FIELDS.LAST_NAME],
	phone: formikValues?.[CONTACT_FORM_FIELDS.PHONE],
	email: formikValues?.[CONTACT_FORM_FIELDS.EMAIL],
	profileUrl: formikValues?.[CONTACT_FORM_FIELDS.PROFILE_URL],
});
